var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pinboard-status position-relative",class:{ pinned: _vm.pinned },attrs:{"aria-checked":_vm.pinned},on:{"click":_vm.toggle}},[_c('icon',{class:{ pinned: _vm.pinned },attrs:{"name":"pin"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }